import { memo, useEffect, useRef } from "react";

const BranchMarker = ({ branch, map }) => {
  const markerRef = useRef(null);
  const imgRef = useRef(null);

  const shouldShowMarker =
    branch?.orders?.some((o) => ["1", "2"].includes(o.status)) ?? false;

  useEffect(() => {
    if (!map || !window.google?.maps?.marker?.AdvancedMarkerElement) return;

    const lat = Number(branch?.location?.lat);
    const lng = Number(branch?.location?.long);

    if (!shouldShowMarker || !Number.isFinite(lat) || !Number.isFinite(lng)) {
      if (markerRef.current) markerRef.current.map = null;
      return;
    }

    if (!markerRef.current) {
      const img = document.createElement("img");
      img.style.width = "55px";
      img.src = `${process.env.REACT_APP_PUBLIC_URL}assets/markers/active_branch_marker.png`;

      markerRef.current = new window.google.maps.marker.AdvancedMarkerElement({
        position: { lat, lng },
        content: img,
        map,
        title: "Branch",
      });
      imgRef.current = img;
      return;
    }

    markerRef.current.position = { lat, lng };
    markerRef.current.map = map;
  }, [branch, map, shouldShowMarker]);

  useEffect(() => {
    return () => {
      if (markerRef.current) {
        markerRef.current.map = null;
        markerRef.current = null;
        imgRef.current = null;
      }
    };
  }, [map]);

  return null;
};

export default memo(BranchMarker);